export default "__VITE_ASSET__BhexcUaQ__"